<template>
  <div class="po-container">
    <div class="po-left">
      <div class="po-label">
        {{ getLabel() }}
      </div>
      <div class="po-desc">
        {{ getDescription() }}
        <template v-if="desc2">
          <div class="ab-desc2" v-html="desc2"></div>
        </template>
      </div>
      <div @click="redirect" class="button">
        {{ $t("pricingOnboard.updateYourPlan") }}
      </div>
    </div>
    <div class="po-right">
      <img v-if="pageId === 'product'" class="po-normal-image" src="../assets/product_onboarding.png" />
      <img v-if="pageId === 'collection'" class="po-normal-image"  src="../assets/collection_onboarding.png" />
      <img v-if="pageId === 'ab-testing'" class="po-normal-image po-image" src="../assets/ab_onboarding.jpg" />
      <img v-if="pageId === 'blog'" class="po-normal-image"  src="../assets/blog_onboarding.png" />
    </div>
  </div>
</template>

<script>
import { DYNAMIC_TRIGGER } from "@/contants/pricing";
export default {
  computed: {
    idABTesting() {
      const { id } = this.$route.params;
      return id === "ab-testing";
    },
    pageId(){
      const { id } = this.$route.params;
      return id
    },
    desc2() {
      const { id } = this.$route.params;
      switch (id) {
        case "product":
          return this.$t("pricingOnboard.productDesc2");
        case "collection":
          return this.$t("pricingOnboard.collectionDesc2");
        case "ab-testing":
          return this.$t("pricingOnboard.abDesc2");
        case "blog":
          return this.$t("pricingOnboard.blogDesc2");
        default:
          return "";
      }
    }
  },
  methods: {
    getImage() {
      const { id } = this.$route.params;
      switch (id) {
        case "product":
          return require("../assets/product_onboarding.svg");
        case "collection":
          return require("../assets/collection_onboarding.svg");
        case "ab-testing":
          return require("../assets/ab_onboarding.png");
        case "blog":
          return require("../assets/blog_onboarding.svg");
        default:
          break;
      }
    },

    getLabel() {
      const { id } = this.$route.params;
      switch (id) {
        case "product":
          return this.$t("pricingOnboard.productTitle");
        case "collection":
          return this.$t("pricingOnboard.collectionTitle");
        case "ab-testing":
          return this.$t("pricingOnboard.abTitle");
        case "blog":
          return this.$t("pricingOnboard.blogTitle");
        default:
          break;
      }
    },

    getDescription() {
      const { id } = this.$route.params;
      switch (id) {
        case "product":
          return this.$t("pricingOnboard.productDesc");
        case "collection":
          return this.$t("pricingOnboard.collectionDesc");
        case "ab-testing":
          return this.$t("pricingOnboard.abDesc");
        case "blog":
          return this.$t("pricingOnboard.blogDesc");
        default:
          break;
      }
    },

    getPathRedirect() {
      const { id } = this.$route.params;
      switch (id) {
        case "product":
          return DYNAMIC_TRIGGER.sidebar_product_page;
        case "collection":
          return DYNAMIC_TRIGGER.sidebar_collection_page;
        case "ab-testing":
          return DYNAMIC_TRIGGER.ab_testing_campaign;
        case "blog":
          return DYNAMIC_TRIGGER.sidebar_blog_page;
        default:
          return "";
      }
    },

    redirect() {
      this.$router.push({
        name: "Pricing",
        query: {
          from: this.getPathRedirect()
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.po-container {
  display: flex;
  justify-content: center;
  padding: 0px -8px;
  padding-top: 54px;
  @media (min-width: 1920px) {
    padding: 20px 40px;
  }
  .po-left {
    // flex: 1;
    display: flex;
    flex-direction: column;
    font-family: "Inter";
    font-style: normal;
    padding-top: 20px;
    .po-label {
      font-weight: 600;
      font-size: 32px;
      line-height: 120%;
      color: #212121;
      margin-bottom: 16px;
      max-width: 425px;
      @media (max-width: 1120px) {
        max-width: 246px;
      }
    }
    .po-desc {
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      color: #676767;
      max-width: 480px;
      @media (max-width: 1120px) {
        max-width: 274px;
      }
      .ab-desc2 {
        margin-top: 24px;
      }
    }
  }
  .po-normal-image {
    width: 488px;
    height: 288px;
    @media (max-width: 1120px) {
      width: 465px;
      height: 288px;
    }
  }
  .po-image {
    width: 472px;
    height: 384px;
  }
  .button {
    background-color: #3c67ff;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 284px;
    height: 40px;
    border-radius: 3px;
    margin-top: 24px;
    color: #fff;
    font-weight: 500;
    font-size: 14px;
    line-height: 150%;
    cursor: pointer;
    &:hover {
      background-color: #2856f8;
    }
  }
}
</style>
